import React, { useEffect, useState } from "react";
import Dropdown, { DropdownOption } from "../Dropdown";
import { useDebounce } from "../../../Utils/ActionUtils";

export interface SelectProps {
  dropDownOptions: DropdownOption[];
  onChange?: (selectedValue: string | number) => any;
  placeholder?: string;
  onSearch?: (search: string | undefined) => void;
  searchWithDebounce?: boolean;
  className?: string;
  value?: string;
  dropdownListClassName?: string;
}

const Select: React.FC<SelectProps> = ({
  dropDownOptions,
  onChange,
  placeholder,
  onSearch,
  searchWithDebounce = false,
  className = "",
  value,
  dropdownListClassName = ""
}) => {
  const [search, setSearch] = useState<string>("");
  const debouncedSearch = useDebounce(search, 1500);
  const [selectedValue, setSelectedValue] = useState<string | number | undefined>(undefined);

  useEffect(() => {
    if (value) {
      setSearch(value);
      setSelectedValue(value);
    } else {
      setSearch("");
      setSelectedValue(undefined);
    }
  }, [value]);

  const onDropdownChange = (selectedValue: string | number) => {
    setSelectedValue(selectedValue);
    const selectedOption = dropDownOptions.find(option => option.value === selectedValue);
    setSearch(
      typeof selectedOption?.label === "string"
        ? selectedOption.label
        : selectedOption?.value.toString() || ""
    );
    onChange && onChange(selectedValue);
  };

  useEffect(() => {
    if (searchWithDebounce) {
      onSearch && onSearch(debouncedSearch);
    } else {
      onSearch && onSearch(search);
    }
  }, [debouncedSearch, onSearch, search, searchWithDebounce]);

  const dropDownOptionWithSelectedValue = dropDownOptions.map(option => {
    if (option.value === selectedValue) {
      return {
        ...option,
        className: "bg-blue-100"
      };
    }
    return option;
  });

  return (
    <Dropdown
      className={className}
      listClassName={`w-full ${dropdownListClassName}`}
      options={dropDownOptionWithSelectedValue}
      onChange={onDropdownChange}
      anchor={
        <input
          className="border border-gray-300 rounded w-full p-2 col-span-4"
          placeholder={placeholder}
          onBlur={() => {
            if (selectedValue) {
              const selectedOption = dropDownOptions.find(option => option.value === selectedValue);

              if (selectedOption) {
                setSearch(
                  typeof selectedOption.label === "string"
                    ? selectedOption.label
                    : selectedOption.value.toString()
                );
              }
            }
          }}
          onChange={e => setSearch(e.target.value)}
          value={search}
        />
      }
      position="bottom-left"
      autoFit={false}
    />
  );
};

export default Select;
